import React, { useState } from 'react';

import { Checkbox } from '../../utilites';
import { groupByLetters } from '../../../helpers/common';
import FilterModal from './FilterModal';
import FacetsLoader from '../Loader/FacetsLoader';

const FacetFilter = ({ options, values, onChange, text }) => {
  const [isOpen, setOpen] = useState(false);

  const shortList = options && options.slice(0, 5);

  const fullList = groupByLetters(options, text === 'Подразделения');

  const handleChange = (value) => {
    onChange({ ...values, [value]: !values[value] });
  };

  const handleClose = () => setOpen(false);

  const handleOpen = () => setOpen(true);

  const renderContent = () => {
    if (options) {
      return (
        <>
          {shortList &&
            shortList.map((f) => (
              <Checkbox
                key={f.value}
                name="cValue"
                label={`${f.value} (${f.count})`}
                value={values[f.value]}
                onChange={() => handleChange(f.value)}
              />
            ))}
          <button type="button" className="button-icontrigger noborder" onClick={handleOpen}>
            Все варианты
          </button>
        </>
      );
    }

    return <FacetsLoader />;
  };

  return (
    <div className="content-inner-data-aside-left">
      <div className="content-card-row-title">{text}</div>
      <div className="content-card-row">{renderContent()}</div>
      <FilterModal
        isOpen={isOpen}
        title={text}
        options={fullList}
        selectedValues={values}
        onClose={handleClose}
        onSubmit={(newValues) => {
          setOpen(false);
          onChange(newValues);
        }}
      />
    </div>
  );
};

export default FacetFilter;
